import React from "react"
import PropTypes from "prop-types"
import PaymentOptionRadioInput from "./payment_option_radio_input"
import RegistrationsPropTypes from "utils/prop_types"

class PaymentMethodOption extends React.Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    paymentMethod: RegistrationsPropTypes.PaymentMethod.isRequired,
    selected: PropTypes.bool.isRequired
  }

  render() {
    const {
      onChange,
      selected,
      paymentMethod: { description, id }
    } = this.props

    return (
      <PaymentOptionRadioInput
        {...{ onChange, selected }}
        id={`payment_method-${id}`}
        name="payment_method"
        value={id}
      >
        {description}
      </PaymentOptionRadioInput>
    )
  }
}

export default PaymentMethodOption
